module.exports = __webpack_public_path__ + "img/wf-finishing-position-11.17a0d145.svg";